import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { Fields } from "./types.js";
addProp(_List, "fields", Fields);
//# sourceMappingURL=list.js.map